// The web app's WaytideApi adapter — bundles this app's existing
// client functions (the localStorage + VITE_API_URL + PostHog-wired singleton in
// `./client`) into the platform-neutral `WaytideApi` the shared @waytide/ui
// surface consumes. Provided once at the web root via <ApiProvider> (see
// main.tsx). The shared miniapp + dashboard hooks then read the client through
// `useApi()` instead of importing this file directly, so they stay portable.

import type { WaytideApi } from "@waytide/ui";
import {
  getPresence,
  getProjectQuestions,
  getProjectWiki,
  getSchematic,
  getTrace,
  listThreadMessages,
  pauseSession,
  postFocusHeartbeat,
  resumeSession,
  sendThreadMessage,
  subscribeChat,
} from "./client";

/** The web-wired data client as the shared `WaytideApi`. Each method is the
 * EXACT one apps/web already exposed; this just packages them so @waytide/ui can
 * be injected rather than reach into a web singleton. */
export const webApi: WaytideApi = {
  subscribeChat,
  getPresence,
  listThreadMessages,
  getTrace,
  sendThreadMessage,
  pauseSession,
  resumeSession,
  getSchematic,
  getProjectWiki,
  getProjectQuestions,
  postFocusHeartbeat,
};
